import { render, staticRenderFns } from "./MessagePushDialog.vue?vue&type=template&id=2aa3c23b&scoped=true"
import script from "./MessagePushDialog.vue?vue&type=script&lang=js"
export * from "./MessagePushDialog.vue?vue&type=script&lang=js"
import style0 from "./MessagePushDialog.vue?vue&type=style&index=0&id=2aa3c23b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa3c23b",
  null
  
)

export default component.exports